import React from "react";
import { Link } from "react-router-dom";
import { Copy, ExternalLink, MoreHorizontal, Pencil, Star } from "lucide-react";
import { Button } from "../../../components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import { RepositoryViewModel } from "../types";

interface RepositoryActionsDropdownProps {
  repository: RepositoryViewModel;
  onToggleFavorite: () => void;
}

const RepositoryActionsDropdown = ({
  repository,
  onToggleFavorite,
}: RepositoryActionsDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={(event) => event.stopPropagation()}
          aria-label={`Actions for ${repository.name}`}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <Link to={`/edit/${repository.owner}/${repository.name}`}>
            <Pencil className="mr-2 h-4 w-4" /> Open editor
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to={repository.repoUrl} target="_blank">
            <ExternalLink className="mr-2 h-4 w-4" /> Open on GitHub
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => navigator.clipboard?.writeText(repository.repoUrl)}
        >
          <Copy className="mr-2 h-4 w-4" /> Copy repository link
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onToggleFavorite}>
          <Star className="mr-2 h-4 w-4" />
          {repository.isFavorite ? "Remove favorite" : "Add favorite"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RepositoryActionsDropdown;
